"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
exports.paramRegex = /(:([^\/?]*)\??)/g;
exports.optionalRegex = /(\/:[^\/]*\?)$/g;
//# sourceMappingURL=regex.js.map